import { Heading, Paragraph } from '@campgladiator/cgui-core.atoms.typography'
import { FitnessBackgroundProps } from '../../TrainerBio.d'
import styles from './FitnessBackground.module.scss'

const FitnessBackground = ({
  texts = [],
  isMobile,
  ...props
}: FitnessBackgroundProps) => {
  const hasFitnessBackgrounds = !!texts.length

  return (
    <section className={styles.wrapper} {...props}>
      <Heading type={isMobile ? 'h4' : 'h5'} className={styles.heading}>
        Fitness Background
      </Heading>
      {hasFitnessBackgrounds && (
        <ul className={styles.list}>
          {texts.map((text, index) => (
            <li key={index}>
              <Paragraph size={isMobile ? 'small' : 'default'} weight="book">
                {text}
              </Paragraph>
            </li>
          ))}
        </ul>
      )}
    </section>
  )
}

export default FitnessBackground
